import {
  Divider,
  FormControlLabel,
  FormHelperText,
  Switch,
  TextField,
  Typography,
} from '@mui/material';

const ResponseLimitSection = ({
  responseLimitEnabled,
  setResponseLimitEnabled,
  maxResponses,
  setMaxResponses,
  limitReachedMessage,
  updateLimitReachedMessage,
  styles,
}) => {
  return (
    <div>
      <Typography
        variant="h6"
        style={{ fontWeight: 'bold', marginBottom: '15px' }}
      >
        Límite de respuestas:
      </Typography>
      <FormControlLabel
        control={
          <Switch
            checked={responseLimitEnabled}
            onChange={(e) => setResponseLimitEnabled(e.target.checked)}
            color="primary"
          />
        }
        label="Habilitar límite de respuestas"
      />
      <FormHelperText style={{ marginLeft: 0, marginBottom: '15px' }}>
        ¿Desea establecer un límite máximo de respuestas para esta encuesta?
      </FormHelperText>

      {responseLimitEnabled && (
        <>
          <div className={styles.input} style={{ marginBottom: '15px' }}>
            <TextField
              label="Número máximo de respuestas"
              type="number"
              value={maxResponses}
              onChange={(e) => {
                const value = parseInt(e.target.value) || 1;
                setMaxResponses(value < 1 ? 1 : value);
              }}
              fullWidth
              size="small"
              inputProps={{ min: 1 }}
              helperText="Cantidad máxima de respuestas permitidas (mínimo 1)"
              placeholder="100"
            />
          </div>
           {/*}   
          <Divider style={{ marginTop: '20px', marginBottom: '20px' }} />

          <Typography
            variant="h6"
            style={{ fontWeight: 'bold', marginBottom: '15px' }}
          >
            Configuración mensaje límite alcanzado
          </Typography>

          <div
            className={styles.input}
            style={{ marginBottom: '15px', marginTop: '15px' }}
          >
            <TextField
              label="Título del mensaje"
              value={limitReachedMessage.title}
              onChange={(e) =>
                updateLimitReachedMessage('title', e.target.value)
              }
              fullWidth
              size="small"
              helperText="Título que se mostrará cuando se alcance el límite"
              placeholder="Encuesta cerrada"
            />
          </div>

          <div className={styles.input} style={{ marginBottom: '15px' }}>
            <TextField
              label="Mensaje principal"
              value={limitReachedMessage.message}
              onChange={(e) =>
                updateLimitReachedMessage('message', e.target.value)
              }
              fullWidth
              size="small"
              multiline
              rows={3}
              helperText="Mensaje que se mostrará al usuario"
              placeholder="Esta encuesta ha alcanzado el número máximo de respuestas permitidas"
            />
          </div>

          <div className={styles.input} style={{ marginBottom: '15px' }}>
            <TextField
              label="Mensaje secundario (opcional)"
              value={limitReachedMessage.secondaryMessage}
              onChange={(e) =>
                updateLimitReachedMessage('secondaryMessage', e.target.value)
              }
              fullWidth
              size="small"
              multiline
              rows={2}
              helperText="Mensaje adicional o de agradecimiento"
              placeholder="Gracias por su interés en participar"
            />
          </div>

          <div className={styles.input} style={{ marginBottom: '15px' }}>
            <TextField
              label="Texto del botón"
              value={limitReachedMessage.buttonText}
              onChange={(e) =>
                updateLimitReachedMessage('buttonText', e.target.value)
              }
              fullWidth
              size="small"
              helperText="Texto del botón para cerrar el mensaje"
              placeholder="Entendido"
            />
          </div>*/}
        </>
      )}
    </div>
  );
};

export default ResponseLimitSection;